import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ac-calendar-view-list',
  templateUrl: './calendar-view-list.component.html',
  styleUrls: ['./calendar-view-list.component.scss']
})
export class CalendarViewListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
